<template>
  <div class="post" v-if="postForm" :style="post.isDraft ? 'padding-bottom: 8px;' : ''">
    <div class="post-header">
      <div class="profile-image" v-if="post.isDraft == false">
        <el-tooltip class="item" :disabled="post.author.title == null" effect="dark" :content="post.author.title" placement="left-start">
          <img :src="post.author.profilePicture != null ? post.author.profilePicture : 'https://via.placeholder.com/200x200'" />
        </el-tooltip>
      </div>
      <div class="drag-icon" v-if="post.isDraft == true">
        <i class="el-icon-s-grid burger"></i>
      </div>
      <div class="user-details">
        <div class="username" v-if="post.isDraft == false" style="max-width: 200px;">
          {{ postForm.owner.fullName }}
          <span v-if="postForm.isUpdated" class="post-time">
            <b><i class="fa fa-pen"></i> {{ $moment(postForm.updateDate).fromNow() }} {{ $t("components.socialhub.postCard.edited") }}</b>
          </span>
          <span v-else class="post-time">
            {{ $moment(postForm.createDate).fromNow() }}
          </span>
          <!-- Eğer gönderiyi düzenlemişse -->
        </div>
        <div class="isdraft" v-if="post.isDraft == true">
          <span>{{ $t("components.socialhub.postCard.draft") }} {{ postForm.type }}</span>
          <i class="fa fa-pen" @click="editSocialHubPost(postForm.id)"></i>
        </div>
        <div class="isrejected" v-if="postForm.status == 2 && post.isDraft == false">
          <i class="fa fa-times-circle"></i>
          <span>{{ $t("components.socialhub.postCard.rejected") }}</span>
        </div>
        <div class="iswaiting" v-if="postForm.status == 0 && post.isDraft == false">
          <i class="fa fa-clock"></i>
          <span>{{ $t("components.socialhub.postCard.waiting") }}</span>
        </div>
        <el-dropdown trigger="click" class="post-actions" @command="handlePostCommand">
          <span class="el-dropdown-link">
            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="'openRegistration#' + postForm.id" icon="el-icon-user-solid" v-if="postForm.isDraft == false">{{ $t("components.socialhub.postCard.openContactRegistration") }}</el-dropdown-item>

            <el-dropdown-item :command="'publishDraft#' + postForm.id" icon="el-icon-s-promotion" v-if="postForm.isDraft == true">{{ $t("components.socialhub.postCard.publishDraft") }}</el-dropdown-item>

            <el-dropdown-item :command="'approvePost#' + postForm.id" icon="el-icon-check" v-if="postForm.status != 1 && postForm.isDraft == false">{{ $t("components.socialhub.postCard.confirmShipment") }}</el-dropdown-item>
            <el-dropdown-item :command="'rejectPost#' + postForm.id" icon="el-icon-error" v-if="postForm.status != 2 && postForm.status != 1 && postForm.isDraft == false">{{ $t("components.socialhub.postCard.rejectPost") }}</el-dropdown-item>

            <el-dropdown-item divided :command="'screenCastPoll#' + postForm.id" icon="el-icon-s-platform" v-if="postForm.type == 1 && postForm.hasScreencast == false && postForm.isDraft == false">{{ $t("components.socialhub.postCard.reflectVoting") }}</el-dropdown-item>
            <el-dropdown-item divided :command="'stopScreenCastPoll#' + postForm.id" icon="el-icon-s-platform" v-if="postForm.type == 1 && postForm.hasScreencast == true && postForm.isDraft == false">{{ $t("components.socialhub.postCard.stopvoting") }}</el-dropdown-item>

            <el-dropdown-item divided :command="'downloadData#' + postForm.id" icon="el-icon-s-data" v-if="(postForm.type == 1 || postForm.type == 2) && postForm.isOver == true && postForm.isDraft == false">{{ $t("components.socialhub.postCard.downloadResult") }}</el-dropdown-item>

            <el-dropdown-item :command="'changePollStatus#' + postForm.id" icon="el-icon-s-release" v-if="postForm.type == 1 && postForm.isDraft == false">{{ $t("components.socialhub.postCard.endVoting") }}</el-dropdown-item>
            <el-dropdown-item divided :command="'changeSurveyStatus#' + postForm.id" icon="el-icon-s-release" v-if="postForm.type == 2 && postForm.isDraft == false && postForm.isOver == false">{{ $t("components.socialhub.postCard.endPoll") }}</el-dropdown-item>
            <el-dropdown-item :command="'changePollStatus#' + postForm.id" icon="fas fa-clipboard-check" v-if="postForm.type == 1 && postForm.isOver == true && postForm.isDraft == false">{{ $t("components.socialhub.postCard.restartVoting") }}</el-dropdown-item>
            <el-dropdown-item divided :command="'changeSurveyStatus#' + postForm.id" icon="fas fa-clipboard-check" v-if="postForm.type == 2 && postForm.isOver == true && postForm.isDraft == false">{{ $t("components.socialhub.postCard.restartPoll") }}</el-dropdown-item>

            <el-dropdown-item divided :command="'sendNotification#' + postForm.id" icon="el-icon-message-solid" v-if="(postForm.type == 1 || postForm.type == 2) && postForm.isOver == false && postForm.isDraft == false">{{ $t("components.socialhub.postCard.sendReminderNotification") }}</el-dropdown-item>

            <el-dropdown-item divided :command="'editPost#' + postForm.id" icon="fas fa-pen">{{ $t("components.socialhub.postCard.editPost") }}</el-dropdown-item>
            <el-dropdown-item :command="'deletePost#' + postForm.id" icon="fas fa-trash">{{ $t("components.socialhub.postCard.deletePost") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="topic-content" v-if="postForm.topic != null">
      <span
        ><b>{{ $t("components.socialhub.postCard.subject") }}</b> {{ postForm.topic.title }}
      </span>
    </div>

    <div class="post-content" v-html="parseUrl(postForm.postText, postForm)"></div>

    <div
      class="post-image"
      @click="
        image = postForm.image;
        imageIndex = postForm.id;
      "
      :style="'background-image: url(' + postForm.image + ');'"
      v-if="postForm.image != null"
    ></div>

    <div class="polls-wrapper" v-if="postForm.type == 1 && postForm.questions.length > 0 && getPollQuestion()" :style="post.joinCount > 0 ? 'margin-bottom: 0px;' : ''">
      <div class="polls-title">
        <span> {{ getPollQuestion().title }} </span>
      </div>

      <div class="polls-list">
        <div class="polls-item" :class="(option.id == getPollQuestion().answer ? 'selected' : '') + ' ' + (postForm.isJoined ? 'isApplied' : '')" v-for="(option, index) in getPollQuestion().options" :key="'option-' + option.id + index" @click="post.isJoined != true ? (getPollQuestion().answer = option.id) : null">
          <span> {{ option.title }} </span>
          <span class="percentage" v-if="postForm.isJoined == true"> {{ "% " + option.percentage }} </span>
          <i class="fa fa-check" v-if="option.id == getPollQuestion().answer && postForm.isJoined != true" aria-hidden="true"></i>
          <div class="polls-bar" :style="'transition: 1s; width: ' + option.percentage + '%;'" v-if="postForm.isJoined == true"></div>
        </div>
      </div>

      <div class="poll-button-container" v-if="postForm.isJoined != true && postForm.type == 1">
        <el-button :loading="loading == 'surveyLoading'" type="primary" :disabled="postForm.isOver" @click="postForm.isJoined = true">
          {{ post.isOver ? $t("components.socialhub.postCard.pollEnded") : $t("components.socialhub.postCard.vote") }}
        </el-button>
      </div>
    </div>

    <div class="surveys-wrapper" v-if="postForm.type == 2 && postForm.isJoined != true">
      <div class="surveys-title">
        <span> {{ postForm.title }}</span>
      </div>

      <div class="survey-join-container" v-if="!surveyOpened">
        <el-button :type="post.isApplied ? '' : 'primary'" :disabled="post.isApplied" :loading="surveyLoading == 'survey-opened'" @click="openSurvey">{{ postForm.isJoined ? $t("components.socialhub.postCard.youJoinedPoll") : $t("components.socialhub.postCard.join") }}</el-button>
        <span class="survey-joined">{{ $t("components.socialhub.postCard.almostTwelveQuestion") }}</span>
      </div>

      <template v-if="surveyOpened && currentQuestionList[currentQuestionIndex]">
        <div class="survey-container">
          <transition name="el-fade-in" mode="out-in">
            <!-- Single line text -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 10" :key="'question-type-10' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-input v-model="currentQuestionList[currentQuestionIndex].answer" :required="currentQuestionList[currentQuestionIndex].isRequired" :placeholder="currentQuestionList[currentQuestionIndex].placeholder" :minlength="currentQuestionList[currentQuestionIndex].minCharAllowed" :maxlength="currentQuestionList[currentQuestionIndex].maxCharAllowed" show-word-limit clearable></el-input>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Multi line text -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 11" :key="'question-type-11' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-input type="textarea" v-model="currentQuestionList[currentQuestionIndex].answer" :required="currentQuestionList[currentQuestionIndex].isRequired" :placeholder="currentQuestionList[currentQuestionIndex].placeholder" :minlength="currentQuestionList[currentQuestionIndex].minCharAllowed" :maxlength="currentQuestionList[currentQuestionIndex].maxCharAllowed" :rows="currentQuestionList[currentQuestionIndex].rows" show-word-limit clearable></el-input>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Email -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 12" :key="'question-type-12' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-input suffix-icon="fas fa-pen" v-model="currentQuestionList[currentQuestionIndex].answer" :required="currentQuestionList[currentQuestionIndex].isRequired" :placeholder="currentQuestionList[currentQuestionIndex].placeholder" minlength="5" maxlength="250" clearable></el-input>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Phone -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 13" :key="'question-type-13' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-input suffix-icon="el-icon-phone" v-model="currentQuestionList[currentQuestionIndex].answer" :required="currentQuestionList[currentQuestionIndex].isRequired" :placeholder="currentQuestionList[currentQuestionIndex].placeholder" minlength="5" maxlength="250" clearable></el-input>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Number -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 14" :key="'question-type-14' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-input-number v-model="currentQuestionList[currentQuestionIndex].answer" :required="currentQuestionList[currentQuestionIndex].isRequired" :min="currentQuestionList[currentQuestionIndex].minValue" :max="currentQuestionList[currentQuestionIndex].maxvalue" :step="currentQuestionList[currentQuestionIndex].step" step-strictly></el-input-number>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Multiple choice question -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 100" :key="'question-type-100' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <div class="choice-questions">
                <el-checkbox v-model="currentQuestionList[currentQuestionIndex].answer" v-for="(options, index) in currentQuestionList[currentQuestionIndex].options" :key="index">
                  {{ options.title }}
                </el-checkbox>
              </div>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Single choice question -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 15" :key="'question-type-15' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <div class="choice-questions">
                <el-radio v-model="currentQuestionList[currentQuestionIndex].answer" :label="index" v-for="(options, index) in currentQuestionList[currentQuestionIndex].options" :key="index">
                  {{ options.title }}
                </el-radio>
              </div>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Select dropdown -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 16" :key="'question-type-16' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-select v-model="currentQuestionList[currentQuestionIndex].answer" :multiple="currentQuestionList[currentQuestionIndex].multipleSelections" :filterable="currentQuestionList[currentQuestionIndex].searchBox" :placeholder="currentQuestionList[currentQuestionIndex].placeholder">
                <el-option v-for="(options, index) in currentQuestionList[currentQuestionIndex].options" :key="index" :label="options.title" :value="options.title"> </el-option>
              </el-select>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Date picker -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 101" :key="'question-type-101' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-date-picker :format="datePickerDisplayFormat()" v-model="currentQuestionList[currentQuestionIndex].answer" :required="currentQuestionList[currentQuestionIndex].isRequired" :placeholder="currentQuestionList[currentQuestionIndex].placeholder" clearable></el-date-picker>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Time picker -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 102" :key="'question-type-102' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <el-time-picker v-model="currentQuestionList[currentQuestionIndex].answer" :required="currentQuestionList[currentQuestionIndex].isRequired" :placeholder="currentQuestionList[currentQuestionIndex].placeholder" format="HH:mm" clearable=""></el-time-picker>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Star rating -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 200" :key="'question-type-200' + currentQuestionIndex">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <div class="rate-container">
                <el-rate v-model="currentQuestionList[currentQuestionIndex].answer"></el-rate>
              </div>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Emotion rating -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 201" :key="'question-type-201'">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <div class="rate-container">
                <el-rate v-model="currentQuestionList[currentQuestionIndex].answer" :icon-classes="['icon-rate-face-1', 'icon-rate-face-2', 'icon-rate-face-3']" void-icon-class="icon-rate-face-off" :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
              </div>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>

            <!-- Slider rating -->
            <div class="survey-question" v-if="currentQuestionList[currentQuestionIndex].type == 202" :key="'question-type-202'">
              <div class="sub-title">{{ currentQuestionList[currentQuestionIndex].title }}</div>
              <div class="rate-container">
                <el-slider v-model="currentQuestionList[currentQuestionIndex].answer" :min="currentQuestionList[currentQuestionIndex].minValue" :max="currentQuestionList[currentQuestionIndex].maxvalue" :step="currentQuestionList[currentQuestionIndex].step"></el-slider>
              </div>
              <span> {{ currentQuestionList[currentQuestionIndex].hint }} </span>
            </div>
          </transition>

          <div class="survey-actions">
            <span
              >{{ currentQuestionList.length }} / <b>{{ currentQuestionIndex + 1 }}</b></span
            >
            <el-button class="survey-button" type="primary" size="small" @click="currentQuestionIndex += 1">{{ $t("components.socialhub.postCard.next") }}</el-button>
          </div>
        </div>
      </template>
    </div>

    <div class="post-joined-count" v-if="post.attendings > 0 && postForm.isDraft == false" :style="postForm.type == 1 || postForm.type == 2 ? 'margin-top:10px;' : ''">
      <span v-if="postForm.type == 1 && postForm.isJoined == true"> {{ postForm.attendings }} {{ $t("components.socialhub.postCard.joinedPeopleVoting") }}</span>
      <span v-if="postForm.type == 2 && postForm.isJoined == true"> {{ postForm.attendings }} {{ $t("components.socialhub.postCard.joinedPeoplePoll") }}</span>
      <span v-if="postForm.topic != null"> {{ postForm.attendings }} {{ $t("components.socialhub.postCard.peopleTalkingAboutIt") }}</span>
    </div>

    <div class="engagement-bar" v-if="postForm.isDraft == false">
      <div class="comments">
        <i class="fa fa-comment"></i>
        <span
          v-if="postForm.comments > 0"
          @click="
            showComments = !showComments;
            showSubComments = false;
          "
        >
          {{ postForm.comments }} {{ $t("components.socialhub.postCard.comment") }}
        </span>
        <span v-if="postForm.comments > 0" @click="addCommentDialog(postForm.id, null)">
          <b :class="commentEditing ? 'comment-button-disbled' : ''"> {{ commentReply ? $t("components.socialhub.postCard.cancel") : $t("components.socialhub.postCard.reply") }} </b>
        </span>
        <!-- User.id == post.author.id ise "Yanıtla" değilse "Yorum yap" yazacak -->
        <span v-if="postForm.comments == 0" @click="addCommentDialog(postForm.id, null)" :class="commentEditing ? 'comment-button-disbled' : ''">{{ $t("components.socialhub.postCard.doComment") }}</span>
      </div>

      <div class="likes" @click="toggleLike">
        <span> {{ postForm.isLiked ? $t("components.socialhub.postCard.youLikedIt") : $t("components.socialhub.postCard.like") }} </span>
        <i :class="(loading == 'toggleLikePost' ? 'el-icon-loading' : 'fa fa-heart') + ' ' + (postForm.isLiked ? 'isLiked' : '')"></i>
      </div>
    </div>

    <!-- Add Comments -->
    <div class="post-comment-content-reply post-reply" v-if="commentReply == true">
      <div class="mention-area-container" v-dragscroll.x>
        <div class="mention-item" v-for="(mentionedUsers, index) in post.lastLikedUsers" :key="'mentionedUsers-123-' + index">
          <img :src="mentionedUsers.profilePicture" />
          <span> {{ mentionedUsers.title }} </span>
        </div>
      </div>

      <div class="reply-area-container">
        <el-input type="textarea" :rows="1" placeholder="" v-model="comment.commentText" resize="none"> </el-input>
        <i v-if="loading == 'addCommentLoading'" class="el-icon-loading"></i>
        <i v-else class="el-icon-s-promotion" @click="addComment"></i>
      </div>

      <div class="post-comment-relpy-actions">
        <span
          @click="
            commentReply = !commentReply;
            $emit('commentReplyChanged', commentReply);
          "
          >{{ $t("components.socialhub.postCard.cancel") }}</span
        >
      </div>
    </div>
    <!-- 
    <el-popover placement="top" width="200" trigger="click" v-if="post.isDraft == false">
      <template>
        <div class="like-popover">
          <div class="like-user-item" v-for="(likedusers, index) in post.lastLikedUsers" :key="'likedusers-a-' + index">
            <el-tooltip class="item" :disabled="likedusers.title == null" effect="dark" :content="likedusers.title" placement="left-start">
              <img :src="likedusers.profilePicture != null ? likedusers.profilePicture : 'https://via.placeholder.com/200x200'" />
            </el-tooltip>
            <span> {{ likedusers.title }} </span>
          </div>

          <infinite-loading @infinite="getPostLikeData" :identifier="identifierComment">
            <div slot="no-more">
              <span> Başka beğeni yok</span>
            </div>

            <div slot="no-results">
              <span> Hiç beğeni yok </span>
            </div>
          </infinite-loading> 
          
        </div>
         
      </template>
     
    </el-popover> -->
    <div class="like-bar" v-if="post.likeCount > 0 && post.isDraft == false" slot="reference">
      <span class="likebar-span" v-if="postForm.isLiked" v-html="$t('components.socialhub.postCard.youAndPeopleLiked', [postForm.likes - 1])"></span>
      <!-- <span class="likebar-span" v-if="postForm.isLiked">Siz ve {{ postForm.likes - 1 }} kişi beğendi</span> -->
      <span class="likebar-span" v-else>{{ postForm.likes }} {{ $t("components.socialhub.postCard.peopleLiked") }}</span>

      <div class="likeusers" v-if="postForm.latestLikes != null">
        <img :src="likedusers.image != null ? likedusers.image : 'https://dummyimage.com/200x200/000/fff&text=At+yal%C4%B1m+abiyi+ka%C3%A7%C4%B1rd%C4%B1'" v-for="(likedusers, index) in postForm.latestLikes" :key="'likedUsersImage-' + index" />
      </div>
    </div>
    <!-- Comments -->
    <div class="post-comments" v-if="showComments == true">
      <Comment v-for="(item, index) in postForm.commentList" :key="item.id + index" :subCommentList="item.subCommentList" :postId="postForm.id" :showComments="showComments" :mentionedUserList="post.lastLikedUsers" :post="item" @deleteMe="deleteComment" @editComment="setOverFlow" />
      <!-- Load Comments -->
      <infinite-loading @infinite="getCommentList">
        <div slot="no-more">
          <span> {{ $t("components.socialhub.postCard.noMoreComment") }}</span>
        </div>
        <div slot="no-results">
          <span> {{ $t("components.socialhub.postCard.noComment") }} </span>
        </div>
      </infinite-loading>

      <div class="dock-comments">
        <span
          @click="
            showComments = false;
            showSubComments = false;
          "
          >{{ $t("components.socialhub.postCard.hideComment") }}</span
        >
      </div>
    </div>
    <!-- End Comments -->

    <!-- Expand Post Images -->
    <gallery :images="[image]" :index="imageIndex" @close="imageIndex = null"></gallery>
  </div>
  <!-- End Post -->
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { dragscroll } from "vue-dragscroll";
import VueGallery from "vue-gallery";
import Comment from "./Comment.vue";

export default {
  name: "PostCard",
  directives: {
    dragscroll
  },
  components: { InfiniteLoading, gallery: VueGallery, Comment },
  props: ["post", "postForm"],
  data() {
    return {
      commentList: [],
      currentQuestionList: [],
      identifierComment: +new Date(),
      comment: {
        id: null,
        commentText: null,
        mentions: []
      },
      commentsFilter: {
        skip: 0,
        take: 5,
        searchTerm: null,
        ids: [],
        postId: null,
        parentId: null
      },
      postId: null,
      currentQuestionIndex: 0,
      parentId: null,
      isLiked: false, //entegrasyondan sorna bu kaldırılacak.
      visible: false,
      selection: null,
      loading: false,
      overflow: false,
      surveyOpened: false,
      commentEditing: false,
      showComments: false,
      showSubComments: false,
      commentReply: false,
      imageIndex: null,
      image: null,
      timeout: null,
      surveyLoading: false,
      changeStatus: 0
    };
  },

  methods: {
    getPollQuestion() {
      return this.postForm.questions[0];
    },
    async getCommentList($state) {
      this.commentsFilter.postId = this.postForm.id;
      var res = await this.$store.dispatch("socialHubListComments", this.commentsFilter);
      if (!res.data.alert.hasError) {
        if (res.data.data.items.length > 0) {
          this.commentsFilter.skip = this.commentsFilter.take;
          this.commentsFilter.take = this.commentsFilter.skip * 2;
          res.data.data.items.reverse().forEach(x => {
            this.postForm.commentList.push({ ...x, subCommentList: [] });
          });
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    async toggleLike() {
      this.loading = "toggleLikePost";
      var dammyLike = !this.postForm.isLiked;
      var res = await this.$store.dispatch("socialHubToggleLike", { id: this.postForm.id, isLiked: dammyLike });
      if (!res.data.alert.hasError) {
        this.postForm.isLiked = dammyLike;
        this.postForm.likes = res.data.data.likes;
        this.postForm.likeCount = res.data.data.likes;
      }
      this.loading = false;
    },
    setOverFlow(stat) {
      this.overflow = !stat;
    },
    async openSurvey() {
      if (!this.postForm.isJoined) {
        this.surveyLoading = "survey-opened";
        if (this.timeout != null) clearTimeout(this.timeout);

        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("getQuestionsObject", { id: this.postForm.id, type: 2 });
          if (!res.data.alert.hasError) {
            this.currentQuestionList = res.data.data.items;
            this.surveyOpened = true;
          } else {
            this.surveyOpened = false;
          }
          this.surveyLoading = false;
        }, 500);
      }
    },
    addCommentDialog(postId, parentId) {
      this.postId = postId;
      this.parentId = parentId;
      this.commentReply = !this.commentReply;
      this.comment.commentText = null;
      this.$emit("commentReplyChanged", this.commentReply);
    },
    async addComment() {
      this.loading = "addCommentLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("socialHubAddUpdateComment", { ...this.comment, parentId: this.parentId, postId: this.postId });
        if (res.data.alert.hasError) {
        } else {
          this.comment.id = null;
          this.comment.commentText = null;
          this.comment.mentions = [];
          this.commentReply = !this.commentReply;
          this.$emit("commentReplyChanged", this.commentReply);
        }
        this.loading = false;
      }, 500);
    },
    async getCommentsData($state) {
      console.log("getCommentsData");
    },
    async getSubCommentsData($state) {
      console.log("getSubCommentsData");
    },
    async getSubCommentsLikeData($state) {
      console.log("getSubCommentsLikeData");
    },
    async getCommentsLikeData($state) {
      console.log("getCommentsLikeData");
    },
    async getPostLikeData($state) {
      console.log("getPostLikeData");
    },
    async handlePostCommand(command) {
      var comm = command.split("#")[0];
      var uid = command.split("#")[1];
      console.log("click on item " + comm + uid);
      switch (comm) {
        case "approvePost":
          this.changeStatus = 1;
          var res = await this.$store.dispatch("socialHubChangeStatus", { id: uid, status: this.changeStatus });
          if (!res.data.alert.hasError) {
            this.postForm.status = 1;
          }
          break;
        case "rejectPost":
          // this.$message('click on item ' + 'rejectPost' + uid);
          this.changeStatus = 2;
          var res = await this.$store.dispatch("socialHubChangeStatus", { id: uid, status: this.changeStatus });
          if (!res.data.alert.hasError) {
            this.postForm.status = 2;
          }
          break;
        case "publishDraft":
          var dummyPost = JSON.parse(JSON.stringify(this.postForm));
          dummyPost.isDraft = false;
          var res = await this.$store.dispatch("socialHubAddOrUpdate", dummyPost);
          if (!res.data.alert.hasError) {
            this.postForm.isDraft = false;
          }
          break;
        case "screenCastPoll":
          var res = await this.$store.dispatch("socialHubToggleHasScreencast", uid);
          if (!res.data.alert.hasError) {
            this.postForm = res.data.data.item;
          }
          break;
        case "stopScreenCastPoll":
          var res = await this.$store.dispatch("socialHubToggleHasScreencast", uid);
          if (!res.data.alert.hasError) {
            this.postForm = res.data.data.item;
          }
          break;
        case "changePollStatus":
          var res = await this.$store.dispatch("socialHubToggleIsOver", this.postForm.id);
          if (!res.data.alert.hasError) {
            this.postForm.isOver = res.data.data.isOver;
          }
          break;
        case "changeSurveyStatus":
          var res = await this.$store.dispatch("socialHubToggleIsOver", this.postForm.id);
          if (!res.data.alert.hasError) {
            this.postForm.isOver = res.data.data.isOver;
          }
          break;
        case "sendNotification":
          this.$message("click on item " + "sendNotification" + uid);
          break;
        case "downloadData":
          if (this.postForm.type == 0) {
            return;
          }
          var type = null;
          if (this.postForm.type == 1) {
            type = 9;
          } else if (this.postForm.type == 2) {
            type = 5;
          }
          this.exportXlsx(type, uid, null);
          break;
        case "editPost":
          this.editSocialHubPost(uid);
          break;
        case "openRegistration":
          this.$message("click on item " + "openRegistration" + uid);
          break;
        case "deletePost":
          if (this.timeout != null) clearTimeout(this.timeout);
          this.showComments = false;
          this.showSubComments = false;
          this.postForm.commentList = [];
          this.commentsFilter.skip = 0;
          this.commentsFilter.take = 5;
          this.identifierComment += 1;
          var res = await this.$store.dispatch("socialHubDelete", { id: uid });
          if (!res.data.alert.hasError) {
            this.$store.commit("deleteSocialPost", uid);
          }
          break;
        case "editComment":
          this.$message("click on item " + "editComment" + uid);
          break;
        case "deleteComment":
          this.$message("click on item " + "deletePost" + uid);
          break;
        case "editSubComment":
          this.$message("click on item " + "deletePost" + uid);
          break;
        case "deleteSubComment":
          this.$message("click on item " + "deletePost" + uid);
          break;
      }
    },
    deleteComment(id) {
      this.postForm.commentList.filter(x => x.id != id);
    },

    parseUrl(text, post) {
      if (text == null) {
        return "";
      }
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      var standName = /\#(.*?)\#/g;
      text = text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });

      post.mentions.forEach(user => {
        if (text.includes("%" + user.id + "%")) {
          text = text.replace("%" + user.id + "%", function(userID) {
            return '<a href="javascript:;" user-id="' + userID.replace("%", "").replace("%", "") + '" class="open-url"> @' + user.fullName + "</a>";
          });
        }
      });

      // text = text.replace(usernameRegex, function(url) {
      //   var user = null;

      //   if (post.mentions != null && post.mentions.some((k) => k.id == url.replace('%', '').replace('%', ''))) {
      //     var user = post.mentions.find((k) => k.id == url.replace('%', '').replace('%', ''));
      //     return '<a href="javascript:;" user-id="' + url.replace('%', '').replace('%', '') + '" class="open-url"> @' + user.fullName + '</a>';
      //   } else {
      //     return url;
      //   }
      // });

      text = text.replace(standName, function(url) {
        var user = null;

        if (post.taggedStands != null && post.taggedStands.some(k => k.id == url.replace("#", "").replace("#", ""))) {
          var user = post.taggedStands.find(k => k.id == url.replace("#", "").replace("#", ""));
          return '<a href="javascript:;" user-id="' + url.replace("#", "").replace("#", "") + '" class="open-url">' + user.title + "</a>";
        } else {
          return url;
        }
      });

      return text;
    }
  },
  async created() {
    var channelId = "event-social-hub-" + this.$store.state.event.event.id;
    // this.$socket.off(channelId + '-commentSubCommentCountChanged');
    this.$socket.on(channelId + "-commentSubCommentCountChanged", data => {
      if (this.postForm != null && this.postForm.id == data.data.PostId) {
        var postIndex = this.postForm.commentList.findIndex(x => x.id == data.data.CommentId);
        if (postIndex != -1) {
          this.postForm.commentList[postIndex].subCommentCount = data.data.SubCommentCount;
          console.log("socket eşleşti");
        }
      }
    });
    // this.$socket.off(channelId + '-postCommentLikeCountChanged');
    this.$socket.on(channelId + "-postCommentLikeCountChanged", data => {
      var postIndex = this.postForm.commentList.findIndex(x => x.id == data.data.CommentId);
      if (postIndex != -1) {
        this.postForm.commentList[postIndex].likeCount = data.data.LikeCount;
      }
    });
    this.$socket.on(channelId + "-newComment", data => {
      var socketData = data.data;
      if (this.showComments == true) {
        if (this.postForm.id == socketData.PostId && socketData.Comment.ParentId == null) {
          this.postForm.commentList.unshift(this.$toCamel(socketData.Comment));
        }
      }
    });

    this.$socket.on(channelId + "-postCommentDeleted", data => {
      var socketData = this.$toCamel(data.data);
      if (this.showComments) {
        var fIndex = this.postForm.commentList.findIndex(x => x.id == socketData.commentId);
        if (fIndex != -1) {
          console.log("postCard");
          this.postForm.commentList.splice(fIndex, 1);
        }
      }
    });
  }
};
</script>

<style scoped>
.infinite-loading-container {
  width: 100%;
  height: 40px;
}
</style>

<style lang="less">
.post {
  margin: 10px 0px;
  width: 100%;
  border-radius: 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid whitesmoke;
  //box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.27);
  //box-shadow: 0px 0px 7px 5px rgba(0, 0, 0, 0.22);
  box-shadow: 0px 2px 18px -6px rgba(0, 0, 0, 0.36);

  .post-content {
    font-size: 14px;
    display: block;
    padding: 5px 10px;
    line-height: 1.4;
    padding-bottom: 0px;
    color: #505763;

    a {
      line-break: anywhere;
      color: #06658c !important;
    }

    .open-url {
      line-break: anywhere;
      color: #06658c !important;
      font-weight: 500;
      display: inline-block;
    }
  }

  .post-image {
    background-size: cover;
    width: calc(~"100% - 15px") !important;
    margin: 8px 7.5px 0px 7.5px;
    border-radius: 8px;
    height: 250px;
    cursor: pointer;
    background-repeat: no-repeat;
    border: 0.5px solid #d6d9d9;
    background-position: center center;
  }

  .post-header {
    display: flex;
    padding: 7px;
    flex-direction: row;
    align-items: center;
    padding-bottom: 0;

    .profile-image {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      margin-right: 10px;

      img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        border: 4px solid #f1f1f1;
        box-sizing: border-box;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .drag-icon {
      width: 38px;
      height: 38px;
      border-radius: 8px;
      margin-right: 10px;
      background: #f1f1f1;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;

      i {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;

        &:hover {
          cursor: grabbing;
        }
      }
    }

    .user-details {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      padding: 0 10px;
      .username {
        margin: 0;
        font-weight: 600;
        font-size: 13px;
        color: #292f3b !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;

        &.duyuru:hover {
          text-decoration: none;
          cursor: unset;
        }

        &:hover {
          color: #333;
          text-decoration: none;
          cursor: pointer;
        }
      }

      .isdraft {
        margin: 0;
        font-weight: 600;
        font-size: 13px;
        flex-shrink: 0;
        color: #292f3b !important;

        span {
          font-size: 16px;
          color: #292f3b;
        }

        i {
          color: #505763;
          cursor: pointer;
          font-size: 14px;
          margin-left: 8px;
          margin-bottom: 3px;
        }
      }

      .isrejected {
        margin: 0;
        font-weight: 600;
        font-size: 13px;
        color: #292f3b !important;
        display: block;
        flex-shrink: 0;

        margin-right: 8px;
        padding: 3px 6px;
        border-radius: 6px;
        background-color: #f5f5f5;

        span {
          font-size: 16px;
          color: #292f3b;
        }

        i {
          color: #ff6565;
          cursor: pointer;
          font-size: 14px;
          margin-right: 1px;
          margin-bottom: 3px;
        }
      }

      .iswaiting {
        margin: 0;
        font-weight: 600;
        font-size: 13px;
        flex-shrink: 0;

        color: #292f3b !important;
        display: block;
        margin-right: 8px;
        flex-shrink: 0;
        padding: 3px 6px;
        border-radius: 6px;
        background-color: #f5f5f5;

        span {
          font-size: 16px;
          color: #292f3b;
        }

        i {
          color: #f69656;
          cursor: pointer;
          font-size: 14px;
          margin-right: 1px;
          margin-bottom: 3px;
        }
      }

      .post-time {
        margin: 0;
        color: #8c929c;
        font-size: 12px;
        line-height: 8px;
        margin-bottom: 5px;
        display: block;
        font-weight: 400;

        b {
          font-weight: 400;

          i {
            font-size: 10px;
            margin-right: 2px;
            margin-left: 2px;
          }
        }
      }

      .post-actions {
        color: #8c929c;
        font-size: 12px;
        text-align: end;
        cursor: pointer;
        padding: 6px 0px;

        span {
          i {
            font-size: 16px;
          }
        }
      }
    }
  }

  .engagement-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 14px;
    margin: 14px 0px;

    .comments {
      font-size: 13px;
      cursor: pointer;

      span {
        color: #505763;
        font-weight: 500;
        margin-right: 6px;

        &:last-child {
          margin-right: unset;
        }

        b {
          text-decoration: underline;
          font-weight: 500;
          color: #292f3b;
          z-index: 3;

          &.comment-button-disbled {
            color: #cfd2d7 !important;
          }
        }
      }

      i {
        margin-right: 4px;
        color: #292f3b;
      }
    }

    .likes {
      font-size: 13px;
      cursor: pointer;

      span {
        color: #505763;
        font-weight: 500;
      }

      i {
        margin-left: 4px;
        color: #292f3b;

        &.isLiked {
          color: #ff6565;
        }
      }
    }
  }

  .like-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 0px 7px;
    margin: 12px 0px;
    cursor: pointer;

    .likebar-span {
      margin-right: 20px;
      color: #505763;
    }

    .likeusers {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid #f1f1f1;
        box-sizing: border-box;
        margin-left: -12px;
      }
    }
  }

  .polls-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 7px;
    margin: 12px 0px;

    .polls-title {
      padding: 6px 8px;
      margin-bottom: 10px;

      span {
        font-weight: 500;
        color: #292f3b;
        font-size: 15px;
      }
    }

    .polls-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;

      .polls-item {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        min-height: 45px;
        width: 100%;
        overflow: hidden;
        background-color: #f5f5f5;
        border: 0.5px solid #d6d9d9;
        border-radius: 8px;
        padding: 8px 10px;
        margin-bottom: 10px;
        cursor: pointer;

        &:last-child {
          margin-bottom: 0px;
        }

        &.isApplied {
          cursor: unset;
        }
        .percentage {
          flex-shrink: 0;
        }
        span {
          font-weight: 500;
          color: #292f3b;
          font-size: 15px;
        }

        i {
          color: #03658c;
          font-size: 16px;
        }

        .polls-bar {
          height: 100%;
          position: absolute;
          left: 0px;
          background-color: rgba(6, 101, 140, 0.5);
        }
      }
    }

    .poll-button-container {
      width: 100%;
      margin-top: 10px;
      padding: 0px 14px;
      margin: 12px 0px;

      button {
        width: 100%;
      }
    }
  }

  .surveys-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 7px;
    margin: 12px 0px;

    .surveys-title {
      padding: 6px 8px;
      margin-bottom: 10px;

      span {
        font-weight: 500;
        color: #292f3b;
        font-size: 15px;
      }
    }

    .survey-join-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100px;
      width: 100%;
      border: 0.5px solid #d6d9d9;
      background-color: #f5f5f5;
      border-radius: 8px;
      padding: 8px 10px;

      button {
        width: 100%;
        padding: 0px 14px;
        margin: 12px 0px;
        height: 40px;
      }

      .survey-joined {
        color: #8c929c;
        font-size: 13px;
        text-align: center;
      }
    }

    .survey-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      min-height: 250px;
      width: 100%;
      border: 0.5px solid #d6d9d9;
      background-color: #f5f5f5;
      border-radius: 8px;
      padding: 8px 10px;

      .survey-question {
        width: 100%;
        transition: 1s;
        margin-top: 18px;

        .sub-title {
          color: #292f3b;
          font-weight: 400;
          margin-bottom: 8px;
          font-size: 14px;
        }

        span {
          color: #505763;
          font-size: 13px;
          font-weight: 400;
        }

        .choice-questions {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          width: 100%;
        }

        .el-input-number {
          width: 100% !important;
        }

        .el-date-editor {
          width: 100% !important;
        }

        .rate-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 150px;

          .el-slider {
            width: 100%;
          }
        }
      }

      .survey-actions {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        span {
          color: #292f3b;
          font-size: 14px;

          b {
            color: #292f3b;
            font-weight: 500;
          }
        }

        .survey-button {
          color: white;

          span {
            color: white;
          }
        }
      }
    }
  }

  .post-joined-count {
    width: 100%;
    margin: 8px 10px 0px 10px;

    span {
      color: #8c929c;
      font-size: 13px;
      display: block;
    }
  }

  .topic-content {
    background-color: #06658c;
    padding: 8px 10px;
    margin: 10px 10px 5px 10px;
    border-radius: 8px;
    cursor: pointer;

    span {
      color: white;
      font-size: 15px;
      font-weight: 500;

      b {
        font-weight: 400;
        margin-right: 0px;
      }
    }
  }

  .post-comment-content-reply {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 6px 4px;
    width: 100%;
    z-index: 1;

    .mention-area-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      width: calc(~"100% - 26px");
      top: -60px;
      padding: 6px 6px;
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 0 14px rgba(0, 0, 0, 0.45);
      overflow: hidden;
      pointer-events: all;

      .mention-item {
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        position: relative;
        cursor: grabbing;

        img {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: 4px solid #f1f1f1;
          box-sizing: border-box;

          &.isRectangle {
            border-radius: 6px !important;
          }
        }

        span {
          margin: 0px 6px;
          font-weight: 600;
          font-size: 13px;
          color: #292f3b !important;
          white-space: nowrap;
        }
      }
    }

    .reply-area-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
      width: calc(~"100% - 18px");

      textarea {
        box-shadow: 0 0 14px rgba(0, 0, 0, 0.45);
      }

      i {
        position: absolute;
        right: 10px;
        font-size: 22px;
        color: #06658c;
        cursor: pointer;
      }
    }

    .post-comment-relpy-actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      width: 100%;
      bottom: -20px;
      padding: 0px 20px;

      span {
        text-decoration: underline;
        font-weight: 400;
        font-size: 14px;
        color: white;
        cursor: pointer;
      }
    }
  }

  .post-comments {
    margin: 8px 7.5px 0px 7.5px;
    border-bottom: 1px solid #f1f3f6;
    border-top: 1px solid #f1f3f6;
    padding: 14px 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    &.sub-comments {
      margin: 0px;
      margin-left: 16px;
      margin-bottom: 14px;

      &:last-child {
        margin-bottom: 0px !important;
        padding-bottom: 0px !important;
      }
    }

    &:last-child {
      border-bottom: unset;
    }

    .dock-comments {
      width: 100%;
      padding-top: 10px;
      display: flex;
      flex-direction: center;
      align-items: center;
      justify-content: center;

      span {
        font-weight: 500;
        color: #292f3b;
        margin-right: 0px;
        background-color: #f5f5f5;
        padding: 4px 12px;
        border-radius: 20px;
        cursor: pointer;
      }
    }

    .post-comment-item {
      display: flex;
      flex-direction: column;
      width: 100%;

      .comment-header {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 0;
        width: 100%;

        .comment-user {
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: flex-start;
          width: 100%;

          img {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            border: 4px solid #f1f1f1;
            box-sizing: border-box;
            cursor: pointer;
          }

          .comment-user-title {
            margin: 0px 6px;
            cursor: pointer;
          }

          b {
            font-weight: 600;
            font-size: 13px;
            color: #292f3b !important;
          }

          span {
            margin: 0;
            color: #8c929c;
            font-size: 12px;
            line-height: 8px;
            margin-bottom: 5px;
            display: block;
            font-weight: 400;

            i {
              font-size: 10px;
              margin-right: 2px;
            }
          }
        }

        .comment-post-action {
          color: #8c929c;
          font-size: 12px;
          cursor: pointer;
          padding: 6px 0px;

          span {
            i {
              color: #8c929c;
              font-size: 16px;
            }
          }
        }
      }

      .post-comment-content {
        font-size: 13px;
        display: block;
        padding: 6px 4px;
        line-height: 1.4;
        padding-bottom: 0px;
        color: #505763;
      }

      .post-comment-content-edit {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
        padding: 6px 4px;

        i {
          position: absolute;
          right: 10px;
          font-size: 22px;
          color: #06658c;
          cursor: pointer;
        }
      }

      .comment-engagement {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 6px 4px;

        .comment-actions {
          font-size: 13px;

          span {
            color: #505763;
            font-weight: 400;
            margin-right: 6px;

            &.comment-show {
              cursor: pointer;
            }

            &.comment-reply {
              text-decoration: underline;
              font-weight: 500;
              color: #292f3b;
              margin-right: 0px;
              cursor: pointer;
            }

            &.comment-button-disbled {
              color: #cfd2d7 !important;
            }
          }
        }

        .comment-like {
          font-size: 13px;
          cursor: pointer;

          span {
            color: #505763;
            font-weight: 400;
            font-size: 13px;
          }
          i {
            margin-left: 4px;
            color: #292f3b;

            &.isLiked {
              color: #ff6565;
            }
          }
        }
      }
    }
  }
}

.like-popover {
  max-height: 300px;
  overflow-y: auto;

  .like-user-item {
    width: 100%;
    margin-bottom: 10px;

    img {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      border: 4px solid #f1f1f1;
      box-sizing: border-box;
    }

    span {
      margin: 0px 6px;
      font-weight: 600;
      font-size: 13px;
      color: #292f3b !important;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/PostCard.vue